export const SET_SCHEDULE_PAGE_INDEX = '@skuSchedule/SET_SCHEDULE_PAGE_INDEX';
export const SET_SCHEDULE_SORT = '@skuSchedule/SET_SCHEDULE_SORT';
export const SET_SCHEDULE_SEARCH_QUERY = '@skuSchedule/SET_SCHEDULE_SEARCH_QUERY';
export const SET_SCHEDULE_FILTER_QUERY = '@skuSchedule/SET_SCHEDULE_FILTER_QUERY';
export const SET_SCHEDULE_MOBILE_FILTERS_VISIBLE = '@skuSchedule/SET_SCHEDULE_MOBILE_FILTERS_VISIBLE';

export const FETCH_SCHEDULES_REQUEST = '@skuSchedule/FETCH_SCHEDULES_REQUEST';
export const FETCH_SCHEDULES_SUCCESS = '@skuSchedule/FETCH_SCHEDULES_SUCCESS';
export const FETCH_SCHEDULES_FAILED = '@skuSchedule/FETCH_SCHEDULES_FAILED';
